var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaveSine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animate-wave",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18H28.5C27.159 18 26.007 16.7145 25.8585 15C25.4145 9.825 24.735 6 21.735 6C18.735 6 17.985 11.373 17.985 18C17.985 24.627 17.235 30 14.235 30C11.235 30 10.557 26.1795 10.1115 21C9.96154 19.2795 8.81104 18 7.46704 18H4.46704",
    stroke: "#28C76F",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7 8",
    strokeDashoffset: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;60",
    dur: "4s",
    repeatCount: "indefinite"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 18H28.5C27.159 18 26.007 16.7145 25.8585 15C25.4145 9.825 24.735 6 21.735 6C18.735 6 17.985 11.373 17.985 18C17.985 24.627 17.235 30 14.235 30C11.235 30 10.557 26.1795 10.1115 21C9.96154 19.2795 8.81104 18 7.46704 18H4.46704",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSine);
export default __webpack_public_path__ + "static/media/wave-sine.a0862a084e93370f7432ca0ef55712ac.svg";
export { ForwardRef as ReactComponent };